import { EncryptStorage } from 'encrypt-storage'

export const encryptStorage = EncryptStorage('secret_key')
